// import { useEffect } from 'react'

import useViewerKrpano from '../hooks/useViewerKrpano'

export default function ViewerPanorama() {
  useViewerKrpano()

  return <div id="viewer-pano-container" className="w-full h-full" />
}
